module.exports = __webpack_public_path__ + "static/media/img6.178f8b97.png";